import React, { useCallback, useEffect, useRef } from 'react';
import RichEditor from '@modules/questionnaires/complexity/richEditor';
import classnames from 'classnames';
// import { findParentNode } from '@utils';
import { RICH_TYPE } from '@components/richEditor/configs';
import { Resizable } from 'react-resizable';

const richTypes = [
  RICH_TYPE.UNDERLINE,
  RICH_TYPE.ITALIC,
  RICH_TYPE.BOLD,
  RICH_TYPE.UNORDERED_LIST,
  RICH_TYPE.ORDERED_LIST,
  RICH_TYPE.LINK,
  RICH_TYPE.TEXT_COLOR,
  RICH_TYPE.FONT_SIZE,
];

function TextEditorItem({
  value,
  colIndex,
  rowIndex,
  editable,
  onClick,
  // onBlur,
  itemKey,
  onChange,
  refreshCount,
  width,
  onWidthChange,
}) {
  // const currentValue = useRef(null);
  const richEditorRef = useRef();
  const onWrapperClick = useCallback(
    (e) => {
      if (e.target?.className !== 'column-resize-drag') {
        onClick(itemKey);
      }
    },
    [itemKey, onClick],
  );
  // const onWrapperBlur = useCallback(() => {
  //   // onBlur(itemKey, currentValue.current);
  // }, [itemKey]);
  // const onEditorChange = useCallback(
  //   (content) => {
  //     currentValue.current = content;
  //     typeof onChange === 'function' && onChange(content);
  //   },
  //   [onChange],
  // );
  const onEditorChange = (content) => {
    // currentValue.current = content;
    if (editable) {
      onChange(itemKey, content);
    }
  };

  useEffect(() => {
    if (editable && richEditorRef.current) {
      richEditorRef.current.focus();
    }
  }, [editable]);

  const onResize = (event, { node, size, handle }) => {
    onWidthChange(size.width, colIndex);
  };

  return (
    <Resizable
      height={10}
      width={width}
      onResize={onResize}
      axis="x"
      resizeHandles={!editable ? [] : ['e']}
      handle={<div className="column-resize-drag" />}
    >
      <div
        className={classnames(['text-editor-item', { active: editable }])}
        // style={style}
        onClickCapture={onWrapperClick}
        // onBlur={onWrapperBlur}
        style={{ gridColumnStart: colIndex + 1, gridRowStart: rowIndex + 1 }}
        data-col-index={colIndex}
        data-row-index={rowIndex}
      >
        <RichEditor
          key={refreshCount}
          value={value}
          readOnly={!editable}
          onChange={onEditorChange}
          ref={richEditorRef}
          richTypes={richTypes}
          // linkPopoverProps={{
          //   // placement: 'leftTop',
          //   getPopupContainer: (triggerNode) =>
          //     // findParentNode(triggerNode, 'text-editor-item'),
          //     findParentNode(triggerNode, 'fix-ratio-div'),
          // }}
        />
      </div>
    </Resizable>
  );
}

export default TextEditorItem;
